import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getBanners = createAsyncThunk(
  "banner/getBanners",
  async ({ currentPage, pageSize, status, title }, { rejectWithValue }) => {
    try {
      let apiUrl = `/api/v1/serviceconnect/banners?has_paginate&size=${pageSize}&page=${currentPage}`;

      if (status) {
        apiUrl += `&status=${status}`;
      }
      if (title) {
        apiUrl += `&search=${title}`;
      }

      const response = await http.get(apiUrl);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "banner/deleteBanner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(
        `/api/v1/serviceconnect/banners/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const toggleBannerStatus = createAsyncThunk(
  "banner/toggleBannerStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.patch(
        `/api/v1/serviceconnect/banners/${id}/toggle-status`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBannerOrder = createAsyncThunk(
  "banner/updateBannerOrder",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await http.put(
        `/api/v1/serviceconnect/banners/update-order`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addBanner = createAsyncThunk(
  "banner/addBanner",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/banners`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBanner = createAsyncThunk(
  "banner/addBanner",
  async ({id, data}, { rejectWithValue }) => {
    try {
      const response = await http.post(
        `/api/v1/serviceconnect/banners/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
